import { FC } from 'react';

export type UploadError = {
  /** お客様向けの案内(原因と次の行動) */
  message: string;
};

interface Props {
  uploadError: UploadError;
  onRetry?: () => void;
  onDismiss?: () => void;
}

export const UploadErrorBar: FC<Props> = ({ uploadError, onRetry, onDismiss }) => (
  <div className="border-t border-red-200 bg-red-50 px-3 py-2 text-sm" role="alert">
    <p className="font-semibold text-red-700">画像を送信できませんでした</p>
    <p className="mt-0.5 text-xs text-red-700">{uploadError.message}</p>
    {(onRetry || onDismiss) && (
      <div className="mt-2 flex justify-end gap-2">
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="rounded border border-gray-300 bg-white px-3 py-1 text-xs font-semibold text-gray-600"
          >
            閉じる
          </button>
        )}
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="bg-brand rounded px-3 py-1 text-xs font-semibold text-white"
          >
            もう一度送る
          </button>
        )}
      </div>
    )}
  </div>
);
